export default "__VITE_ASSET__Do7asDsW__"